import Guid from "common/values/guid/guid";

export type EntityMemberAPIRequestPayload = {
  userId?: string;
  entityId?: string;
};

export default class EntityMemberAPIRequest {
  userId?: string;
  entityId?: string;

  constructor(userId?: Guid, entityId?: Guid) {
    this.userId = userId?.value;
    this.entityId = entityId?.value;
  }

  get payload(): EntityMemberAPIRequestPayload {
    return {
      userId: this.userId,
      entityId: this.entityId,
    };
  }
}
